import dynamic from 'next/dynamic';
import { getSiteStaticProps } from '@/utils/siteStaticProps';

const WebcamsContent = dynamic(() => import('@/components/SitePages').then(module => module.WebcamsPage), {
  ssr: false,
});

export default function WebcamsPage() {
  return <WebcamsContent />;
}

export const getStaticProps = getSiteStaticProps({
  includeBanners: true,
  seo: { page: 'Webcam' },
});
